module.exports = __webpack_public_path__ + "static/media/Frame5.03f45e8e.png";